<template>
  <v-dialog v-model="empresaDialog" max-width="1024" scrollable>
    <DialogSairSemSalvar :dialog="dialogSair" @dialogClose="setDialogSair" @funcaoSair="funcaoSair" />
    <v-card>
      <v-card-title>
        <v-icon left>location_city</v-icon>Cadastro de Empresa
        <v-spacer />
        <v-btn icon @click="dialogClose">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <input name="id" :id="empresa.id" />
        <v-row>
          <v-col cols="12" sm="3" md="3">
            <v-text-field :readonly="!userAdmin" label="CPF/CNPJ" v-model="empresa.cpfcnpj"
              v-mask="['###.###.###-##', '##.###.###/####-##']" />
          </v-col>
          <v-col cols="12" sm="5" md="5">
            <v-text-field label="Razão Social" v-model="empresa.nomerazao" :readonly="!userAdmin" />
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-text-field label="Nome Fantasia" v-model="empresa.nomefantasia" :readonly="!userAdmin" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="3" md="5">
            <v-text-field label="Logradouro" v-model="empresa.logradouro" :readonly="!userAdmin" />
          </v-col>
          <v-col cols="12" sm="5" md="4">
            <v-text-field label="Complemento" v-model="empresa.complemento_end" :readonly="!userAdmin" />
          </v-col>
          <v-col cols="12" sm="5" md="1">
            <v-text-field label="Nrº" type="number" min="0" v-model="empresa.numero_end" :readonly="!userAdmin" />
          </v-col>
          <v-col cols="12" sm="4" md="2">
            <v-text-field label="CEP" v-model="empresa.cep" v-mask="['#####-###']" :readonly="!userAdmin" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="3" md="3">
            <v-text-field label="Cidade" v-model="empresa.cidade" :readonly="!userAdmin" />
          </v-col>
          <v-col cols="12" sm="1" md="1">
            <v-text-field label="UF" v-model="empresa.uf" maxlength="2" :readonly="!userAdmin" />
          </v-col>
          <v-col cols="12" sm="5" md="5">
            <v-text-field label="E-mail" v-model="empresa.email" :readonly="!userAdmin" />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-text-field label="Vl. Entrega (R$)" v-model="empresa.valorentrega" v-mask="['#,##', '##,##', '###,##']"
              :readonly="!userAdmin" />
          </v-col>
        </v-row>
        <v-row :key="renderizar">
          <v-col cols="12" sm="2" md="2">
            <v-text-field label="WhatsApp" v-model="empresa.whatsapp"
              v-mask="['(##) ####-####', '(##) ####-#####', '(##) # ####-####']" :readonly="!userAdmin" />
          </v-col>
          <v-col cols="12" sm="2" md="2">
            <v-text-field label="Telefone" v-model="empresa.telefone"
              v-mask="['(##) ####-####', '(##) ####-#####', '(##) # ####-####']" :readonly="!userAdmin" />
          </v-col>
          <v-col cols="12" sm="2" md="8" v-if="empresa.api_key">
            <v-text-field label="api-key" readonly v-model="empresa.api_key" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field label="Localização" v-model="empresa.localizacao" :readonly="!userAdmin" />
          </v-col>
        </v-row>
        <v-row v-if="msgErro" class="my-0">
          <v-col>
            <p style="color: red; font-weight: bold">
              {{ this.msgErro }}
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn color="success" @click="salvarEmpresa" v-if="userAdmin">
              <v-icon left>mdi-content-save</v-icon>
              Salvar
            </v-btn>
            <v-btn class="mx-1" color="error" :disabled="loading" @click="excluirEmpresa()" v-if="userMaster">
              <v-icon left>mdi-delete</v-icon>
              Excluir
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-tabs v-model="tab" grow optional>
              <v-tab key="Catalogos" @click.native.prevent.stop.capture="goToCatalogos()"
                v-if="userAdmin && !tabVisibility">
                <v-icon left>computer</v-icon>Catalogos
              </v-tab>
              <v-tab key="Pedidos" @click.native.prevent.stop.capture="goToDashboard()"
                v-if="userAdmin && !tabVisibility">
                <v-icon left>mdi-view-dashboard</v-icon>Dashboard
              </v-tab>
              <v-tab key="Configuracoes" @click="loadConfiguracoes" v-if="userAdmin && !tabVisibility">
                <v-icon left>settings</v-icon>Configurações
              </v-tab>
              <v-tabs-items v-model="tab">
                <v-tab-item key="catalogosTab" v-if="userAdmin && !tabVisibility">
                  <Catalogos :catalogos="this.catalogos" @loadCatalogos="loadCatalogos" />
                </v-tab-item>
                <v-tab-item key="dashboardTab" v-if="userAdmin && !tabVisibility">
                  <Dashboard :dashboard="this.dashboard" />
                </v-tab-item>
                <v-tab-item key="configuracoesTab" v-if="userAdmin && !tabVisibility">
                  <Configuracoes :configuracoes="this.configuracoes" :id="this.empresaId" @fecharTab="fecharTab"
                    :empresaToken="this.empresaToken" />
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-progress-linear v-if="loading" indeterminate color="primary" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import Catalogos from "./Catalogos";
import Configuracoes from "./configuracoes/Configuracoes.vue";
import Dashboard from "./Dashboard";
import DialogSairSemSalvar from "./configuracoes/DialogSairSemSalvar.vue";

export default {
  props: {
    empresaId: String,
    empresaToken: String,
    insert: Boolean,
    dialog: Boolean,
  },
  components: {
    Catalogos,
    Dashboard,
    Configuracoes,
    DialogSairSemSalvar,
  },
  data: function () {
    return {
      empresa: {},
      tab: null,
      loading: false,
      msgErro: "",
      catalogos: [],
      dashboard: {},
      configuracoes: {},
      renderizar: false,
      configuracoesOld: {},
      dialogSair: false,
      funcaoSair: () => { },
    };
  },
  computed: {
    ...mapGetters(["userAdmin", "userMaster"]),
    ...mapState(["user"]),
    empresaDialog: {
      get() {
        return this.dialog;
      },
      set() {
        this.dialogClose();
      },
    },
    tabVisibility() {
      if (this.insert) return true;
      return false;
    },
  },
  methods: {
    dialogClose() {
      if (!this.validaConfiguracoes()) {
        this.funcaoSair = this.close;
        this.setDialogSair();
        return;
      }
      this.close();
    },
    close() {
      this.empresa = {};
      this.msgErro = "";
      this.$emit("dialogClose");
    },

    async loadEmpresa() {
      try {
        this.loading = true;
        this.configuracoes = this.configuracoesOld = {};
        this.tab = null;
        if (this.empresaToken && this.empresaId) {
          const response = await this.axios.get(`/empresas/${this.empresaId}`, {
            headers: { Authorization: `Bearer ${this.empresaToken}` },
          });
          this.empresa = response.data;
          this.empresa.valorentrega = this.empresa.valorentrega.replace(
            ".",
            ","
          );
        }
      } catch (error) {
        this.$store.dispatch("showError", error);
      } finally {
        this.loading = false;
      }
      this.renderizar = !this.renderizar;
    },
    salvarEmpresa() {
      try {
        this.loading = true;

        if (this.insert) {
          this.salvaEmpresaAPI();
        } else {
          if (!this.validaConfiguracoes()) {
            this.funcaoSair = this.alteraEmpresaAPI;
            this.setDialogSair();
            return;
          }
          this.alteraEmpresaAPI();
        }
      } catch (error) {
        this.$store.dispatch("showError", error);
      } finally {
        this.loading = false;
      }
    },
    async salvaEmpresaAPI() {
      const response = await this.axios.post("/empresas", {
        nomerazao: this.empresa.nomerazao,
        nomefantasia: this.empresa.nomefantasia,
        cpfcnpj: this.empresa.cpfcnpj,
        logradouro: this.empresa.logradouro,
        complemento_end: this.empresa.complemento_end,
        uf: this.empresa.uf,
        cidade: this.empresa.cidade,
        cep: this.empresa.cep,
        numero_end: this.empresa.numero_end,
        email: this.empresa.email,
        telefone: this.empresa.telefone,
        whatsapp: this.empresa.whatsapp,
        localizacao: this.empresa.localizacao,
        valorentrega: this.empresa.valorentrega,
      });

      if (response.status != 201) {
        this.msgErro = response.data.msg;
      } else {
        this.dialogClose();
      }
    },
    async alteraEmpresaAPI() {
      const response = await this.axios.put(
        `/empresas/${this.empresaId}`,
        {
          nomerazao: this.empresa.nomerazao,
          nomefantasia: this.empresa.nomefantasia,
          cpfcnpj: this.empresa.cpfcnpj,
          logradouro: this.empresa.logradouro,
          complemento_end: this.empresa.complemento_end,
          uf: this.empresa.uf,
          cidade: this.empresa.cidade,
          cep: this.empresa.cep,
          numero_end: this.empresa.numero_end,
          email: this.empresa.email,
          telefone: this.empresa.telefone,
          whatsapp: this.empresa.whatsapp,
          localizacao: this.empresa.localizacao,
          valorentrega: this.empresa.valorentrega,
        },
        { headers: { Authorization: `Bearer ${this.empresaToken}` } }
      );

      if (response.status != 204) {
        this.msgErro = response.data.msg;
      } else {
        this.dialogClose();
      }
    },
    async loadCatalogos() {
      try {
        if (this.loading) return;
        this.loading = true;
        this.tab = 0;

        const response = await this.axios.get(`/empresas/${this.empresaId}/catalogos`);
        this.catalogos = response.data;
      } catch (error) {
        this.$store.dispatch("showError", error);
      } finally {
        this.loading = false;
      }
    },
    async loadDashboard() {
      try {
        if (this.loading) return;
        this.loading = true;
        this.tab = 1;

        const response = await this.axios.get(
          `/empresas/${this.empresaId}/dashboard`
        );
        this.dashboard = response.data;
      } catch (error) {
        this.$store.dispatch("showError", error);
      } finally {
        this.loading = false;
      }
    },
    async loadConfiguracoes() {
      try {
        if (this.loading) return;
        this.loading = true;
        const response = await this.axios.get(`/empresas/${this.empresaId}/configuracoes`);
        this.configuracoes = response.data;
        this.configuracoesOld = { ...this.configuracoes };
      } catch (error) {
        this.$store.dispatch("showError", error);
      } finally {
        this.loading = false;
      }
    },
    fecharTab() {
      this.configuracoesOld = { ...this.configuracoes };
      this.tab = null;
    },
    formatarCpfCnpj(value) {
      if (value) {
        if (value.length < 15) {
          return "###.###.###-##";
        } else {
          return "##.###.###/####-##";
        }
      }
    },
    async excluirEmpresa() {
      try {
        this.loading = true;
        await this.axios.delete(`/empresas/${this.empresaId}/`);
        this.$store.dispatch("showSuccess", "Empresa excluída com sucesso!");
        this.dialogClose();
      } catch (error) {
        this.$store.dispatch("showError", error);
      } finally {
        this.loading = false;
      }
    },
    validaConfiguracoes() {
      if (JSON.stringify(this.configuracoes) !== JSON.stringify(this.configuracoesOld))
        return false;
      return true;
    },
    goToDashboard() {
      if (!this.validaConfiguracoes()) {
        this.funcaoSair = this.loadDashboard;
        this.setDialogSair();
        window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
        return;
      } else
        this.loadDashboard();
    },
    goToCatalogos() {
      if (!this.validaConfiguracoes()) {
        this.funcaoSair = this.loadCatalogos;
        this.setDialogSair();
        return;
      }
      this.loadCatalogos();
    },
    setDialogSair() {
      this.dialogSair = !this.dialogSair;
    },
  },
  watch: {
    empresaId() {
      this.loadEmpresa();
    },
  },
};
</script>
